export default __webpack_public_path__ + "static/media/webhook.3af29936.svg";